export default __webpack_public_path__ + "static/media/expl-dissect_05_DE.1d5faa51.png";